import _styled from "styled-components";
import { HiringPeopleIllustration } from '@restworld/utils-common'; // eslint-disable-next-line @typescript-eslint/no-empty-interface

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Banner(_ref) {
  var title = _ref.title,
      description = _ref.description;
  return /*#__PURE__*/_jsx(_StyledDiv, {
    children: /*#__PURE__*/_jsxs(_StyledDiv2, {
      children: [/*#__PURE__*/_jsxs(_StyledDiv3, {
        children: [/*#__PURE__*/_jsx(_StyledDiv4, {
          children: title
        }), /*#__PURE__*/_jsx(_StyledDiv5, {
          children: description
        })]
      }), /*#__PURE__*/_jsx(HiringPeopleIllustration, {
        width: '95px',
        height: '95px'
      })]
    })
  });
}
export default Banner;

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "banner___StyledDiv",
  componentId: "sc-1um3kpu-0"
})({
  "display": "inline-flex",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "0.625rem",
  "borderRadius": "15px",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(229 231 235 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "padding": "1rem"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "banner___StyledDiv2",
  componentId: "sc-1um3kpu-1"
})({
  "display": "flex",
  "flexShrink": "1",
  "flexGrow": "1",
  "flexBasis": "0px",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "0.5rem"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "banner___StyledDiv3",
  componentId: "sc-1um3kpu-2"
})({
  "display": "inline-flex",
  "flexShrink": "1",
  "flexGrow": "1",
  "flexBasis": "0px",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "0.5rem"
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "banner___StyledDiv4",
  componentId: "sc-1um3kpu-3"
})({
  "alignSelf": "stretch",
  "fontSize": "0.875rem",
  "lineHeight": "21px",
  "fontWeight": "600",
  "--tw-text-opacity": "1",
  "color": "rgb(17 24 39 / var(--tw-text-opacity))"
});

var _StyledDiv5 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "banner___StyledDiv5",
  componentId: "sc-1um3kpu-4"
})({
  "alignSelf": "stretch",
  "fontSize": "0.875rem",
  "lineHeight": "21px",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(75 85 99 / var(--tw-text-opacity))"
});